import * as React from "react";
const SvgPart20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M20 2H0v16h20V2ZM2 16V4h16v12H2Zm8-9-3 3 3 3 3-3-3-3Z",
      clipRule: "evenodd"
    })
  );
export default SvgPart20Px;
